<template>
  <div>
    <header>
      <nav class="navbar is-primary" role="navigation" aria-label="dropdown navigation">
        <div class="navbar-brand">
          <div class="navbar-item has-background-white">
            <img src="@/assets/IDHAlogga.svg" alt="IDHA logo">
          </div>
          <a role="button" class="navbar-burger burger" aria-label="menu" @click.prevent="showMenu = !showMenu">
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
        </div>
        <div class="navbar-menu" :class="showMenu && 'is-active'">
          <div class="navbar-start">
            <router-link class="navbar-item" to="/">{{$t('workshop-registration-tool', 'Workshop registration tool')}}</router-link>
            <router-link to="/registrations" class="navbar-item">
              <font-awesome-icon icon="list" fixed-width />&nbsp;{{$t('registrations', 'Registrations')}}
            </router-link>
            <router-link v-if="role === 'Administrator'" to="/users" class="navbar-item">
              <font-awesome-icon icon="user" fixed-width />&nbsp;{{$t('users', 'Users')}}
            </router-link>
          </div>
          <div class="navbar-end">
            <div class="navbar-item">
              <language-selector />
            </div>
            <a class="navbar-item" href="" @click.prevent="logout">
              <font-awesome-icon icon="sign-out-alt" fixed-width />&nbsp; {{$t('sign-out', 'Sign out')}}
            </a>
          </div>
        </div>
      </nav>
    </header>
    <main>
      <router-view />
    </main>
    <!-- <footer class="footer">
      <div class="container has-text-centered">
        <p></p>
      </div>
    </footer> -->
  </div>
</template>

<script>
import auth from '../auth'
import LanguageSelector from '@/components/LanguageSelector'

export default {
  name: 'Home',
  data () {
    return {
      showMenu: false
    }
  },
  components: { LanguageSelector },
  methods: {
    logout () {
      auth.logout()
    }
  },
  computed: {
    username () {
      return auth.getUsername()
    },
    role () {
      return auth.getUserRole()
    }
  }
}
</script>
